import { z } from "zod";

export const createComponentSchemas = <
  UID extends string,
  S extends z.ZodRawShape,
>(
  uid: UID,
  baseSchema: z.ZodObject<S>,
) => {
  const dynamicSchema = baseSchema.extend({
    __component: z.literal(uid),
    id: z.number(),
  });

  return {
    base: baseSchema,
    dynamic: dynamicSchema,
  };
};
